/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useRef, useEffect} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../_metronic/helpers'
import {StepperComponent} from '../../../../../_metronic/assets/ts/components'
import {useToast} from '../../../components/Toats'
import {LoadingSpan} from '../../../components/Loadings/loadingSpan'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {StepModal} from './components/stepModal'
import {postTypeServiceOne, putTypeServiceAll} from '../../../../services/typeServices'

type DataForm = {
  description: string | null
  details: string | null
  image: string | null
  preco: number | null
  idsUnitBranch: string[] | []
}

type Props = {
  id?: string
  data?: any
  show: boolean
  handleClose: () => void
}

const validationSchema = Yup.object().shape({
  description: Yup.string().required('Informe o nome do serviço'),
  details: Yup.string().nullable(),
  image: Yup.string().nullable(),
  preco: Yup.number().nullable(),
  idsUnitBranch: Yup.array().of(Yup.string()).notRequired().default([]),
})

const modalsRoot = document.getElementById('root-modals') || document.body

const ModalAddUpdateClient = ({show, handleClose, data, id}: Props) => {
  const {toggleToast} = useToast()
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)

  const emptyValues: DataForm = {
    description: null,
    details: null,
    image: null,
    preco: 0,
    idsUnitBranch: [],
  }

  const [initialValues, setInitialValues] = useState<DataForm>(emptyValues)
  const [hasError, setHasError] = useState(false)
  const [loading, setLoading] = useState(false)

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const updateData = (fieldsToUpdate: any) => {
    const updatedData = {...initialValues, ...fieldsToUpdate}
    setInitialValues(updatedData)
  }

  const checkInputs = (): boolean => {
    if (!formik.values.description) {
      return false
    }
    return true
  }

  const closed = () => {
    formik.setValues(emptyValues)
    handleClose()
  }

  const buildPayload = () => {
    const myData: any = {
      description: formik.values.description,
      details: formik.values.details,
      image: formik.values.image,
      preco: formik.values.preco ?? 0,
      idsUnitBranch: formik.values.idsUnitBranch,
    }

    Object.keys(myData).forEach((prop) => {
      if (myData[prop] === undefined) {
        delete myData[prop]
      }
    })

    return myData
  }

  const postTypeServiceSubmit = async () => {
    try {
      setLoading(true)
      await postTypeServiceOne(buildPayload())
      toggleToast('Sucesso ao cadastrar o serviço.', 'success')
    } catch (error) {
      console.log('erro', error)
      toggleToast('Erro ao cadastrar o serviço.', 'error')
    } finally {
      setLoading(false)
      closed()
    }
  }

  const updateTypeServiceSubmit = async (serviceId: string) => {
    try {
      setLoading(true)
      await putTypeServiceAll(buildPayload(), serviceId)
      toggleToast('Sucesso ao atualizar o serviço.', 'success')
    } catch (error) {
      console.log('erro', error)
      toggleToast('Erro ao atualizar o serviço.', 'error')
    } finally {
      setLoading(false)
      closed()
    }
  }

  const submit = () => {
    if (id) {
      updateTypeServiceSubmit(id)
    } else {
      postTypeServiceSubmit()
    }
  }

  const nextStep = () => {
    setHasError(false)
    if (!checkInputs()) {
      setHasError(true)
      return
    }
    submit()
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnChange: false,
    onSubmit: nextStep,
  })

  useEffect(() => {
    if (data) {
      formik.setValues({
        description: data.description ?? null,
        details: data.details ?? null,
        image: data.image ?? null,
        preco: data.preco ?? 0,
        idsUnitBranch: data.idsUnitBranch ?? [],
      })
    } else {
      formik.setValues(emptyValues)
    }
  }, [show, data])

  return createPortal(
    <Modal
      id='kt_modal_create_service'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-650px'
      show={show}
      onHide={closed}
      backdrop={true}
      onEntered={loadStepper}
    >
      <div className='modal-header'>
        <h3 className='card-title align-items-start flex-column' style={{display: 'flex', flexDirection: 'column'}}>
          <span className='card-label fw-bold fs-3 mb-1'>
            {id ? 'Editar' : 'Adicionar'} Serviço
          </span>
          <span className='text-muted mt-1 fw-semibold fs-7'>
            Cadastre foto, preço e filiais vinculadas
          </span>
        </h3>

        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={closed}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
      </div>

      <div className='modal-body py-lg-8 px-lg-10'>
        <div
          ref={stepperRef}
          className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
          id='kt_modal_create_service_stepper'
        >
          <div className='flex-row-fluid py-lg-1 px-lg-2'>
            <form noValidate id='kt_modal_create_service_form'>
              <StepModal
                data={initialValues}
                updateData={updateData}
                hasError={hasError}
                formik={formik}
              />

              <div className='d-flex flex-stack pt-8' style={{justifyContent: 'end'}}>
                <div style={{display: 'flex', gap: '1rem'}}>
                  <button
                    type='button'
                    className='btn btn-lg btn-light'
                    disabled={loading}
                    onClick={closed}
                  >
                    Cancelar
                  </button>
                  <button
                    type='button'
                    className='btn btn-lg btn-primary'
                    disabled={loading}
                    onClick={nextStep}
                  >
                    {id ? 'Salvar' : 'Cadastrar'}{' '}
                    {loading ? (
                      <LoadingSpan style={{marginLeft: '0.5rem'}} />
                    ) : (
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr064.svg'
                        className='svg-icon-3 ms-2 me-0'
                      />
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export {ModalAddUpdateClient}
